import { Card, Row, Form, Col, Input, Button, Spin } from "antd";
import EmptyHeaderHero from "../EmptyHeaderHero";
import OptOutStyle from './RecordingOptOut.module.css'
import { useState } from "react";
import InputMask from 'react-input-mask'
import { LoadingOutlined } from "@ant-design/icons/lib/icons";
import { setRecordingOptOut } from "../../services/Api";

const inputClassName = `ant-input-affix-wrapper input-text ${OptOutStyle.inputText}`

export default function RecordingOptOut() {
  const [isSuccess, setIsSuccess] = useState(null)

  return (
    <>
      <EmptyHeaderHero title="Call Recording Distribution Opt Out" titleStyle={{height: "100% !important"}}/>
      <div className={`${OptOutStyle["optout-screen"]}`}>
        <Row>
          <Card className={`${OptOutStyle["optout-card"]}`}>
            {isSuccess != null ? <p>Your preference has been recorded. Thank you!</p> : <OptOutForm setIsSuccess={setIsSuccess}/>}
          </Card>
        </Row>
      </div>
    </>
  )
  
  function OptOutForm({setIsSuccess}) {
    const [info, setInfo] = useState({firstName: "", lastName: "", phoneNumber: ""})
    const [isLoading, setIsLoading] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)

    const handleKeyDown = event => {
      if (event.key === 'Enter' && !isFormValid()) {
        handleSubmit()
      }
    }

    const handleInputChange = (fieldName, value) => {
      setInfo(prev => {
        const updated = {...prev,
          [fieldName]: value
        }
        console.log(updated)
        validateForm(updated)
        return updated
      })
    }

    const handleSubmit = async () => {
      if(isLoading)
        return
      setIsLoading(true)
      
      const resp = await setRecordingOptOut(info)

      setIsSuccess(true)
    }

    const validateForm = ({firstName, lastName, phoneNumber}) => {
      const firstNameValid = firstName.length != 0
      const lastNameValid = lastName.length != 0
      const phoneNumberValid = !phoneNumber.includes("_") && phoneNumber.length != 0
      const isValid = firstNameValid && lastNameValid && phoneNumberValid
      setIsFormValid(isValid)
    } 

    return (
      <>
        <p>
          Recordings may be securely reviewed, analyzed, or shared with trusted technology partners under 
          strict confidentiality and privacy safeguards. Personal information, if any, will be protected 
          in accordance with our privacy policy.
        </p>
        <p>
          If you do not want your call recordings shared with technology partners, please complete the form below and click SUBMIT. 
        </p>
        <p>
          <strong>You MUST enter the phone number you call from to ensure your preference is followed.</strong>
        </p>
        <h5 style={{marginBottom: "5px"}}>Caller Information</h5>
        <Row>
          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
            <Form.Item style={{marginBottom: "14px"}}>
              <Input
                autoComplete="off"
                className={inputClassName}
                placeholder="First Name*"
                onChange={e => handleInputChange("firstName", e.target.value)}
                onKeyDown={handleKeyDown}
                value={info.firstName}
              />
            </Form.Item>
          </Col>
          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
            <Form.Item style={{marginBottom: "14px"}}>
              <Input
                autoComplete="off"
                className={inputClassName}
                placeholder="Last Name*"
                onChange={e => handleInputChange("lastName", e.target.value)}
                onKeyDown={handleKeyDown}
                value={info.lastName}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
            <Form.Item style={{marginBottom: "14px"}}>
              <span className={inputClassName}>
                <InputMask
                  autoComplete="off"
                  className="ant-input"
                  mask="(999) 999-9999"
                  onChange={e => handleInputChange("phoneNumber", e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Phone Number*"
                  value={info.phoneNumber}
                />
              </span>
            </Form.Item>
          </Col>
        </Row>
        <Row style={{margin: "2rem"}}>
          <Col xl={{ span: 16 }} xs={{ span: 24 }} className={OptOutStyle.alignCenter}>
            <Button
              className={OptOutStyle.submitButton}
              disabled={!isFormValid}
              onClick={() => handleSubmit()}
            >
              SUBMIT
            </Button>
            {isLoading && <Spin indicator={<LoadingOutlined spin style={{ fontSize: 24 }} />} style={{ marginLeft: 24 }} />}
          </Col>
        </Row>
      </>
    )
  }
}